import { exact, number, string } from "prop-types";
import { Card, Heading, Separator } from "uikit/components";
import styles from "./MunicipalitySummaryView.module.styl";
import { toDateStringLocale, toShortDateStringLocale } from "utils";
import React from "react";
import MunicipalityIndicatorCard from "../MunicipalityIndicatorCard/MunicipalityIndicatorCard";
import MunicipalitySummaryCard from "../MunicipalitySummaryCard/MunicipalitySummaryCard";
import { useHistory } from "react-router";

export default function MunicipalitySummaryView({
    currentDate,
    previousWeekStartDate,
    previousWeekEndDate,
    currentWeekStartDate,
    currentWeekEndDate,
    municipalitySummaryData,
    municipalityRatingModel,
    municipalityStatsModelStatsModel,
    municipalityId,
}) {
    const history = useHistory();

    const redirectToMunicipalitySchoolsAttendance = function () {
        history.push(`/attendance/municipality/${municipalityId}`);
    };

    const redirectToMunicipalityTrainingPlans = function () {
        history.push(`/training-plans/municipality/${municipalityId}`);
    };

    return (
        <Card borderRadius={"giant"} padding={"none"} className={styles.form}>
            <Heading size={"h2"} className={styles.viewHeading} name="municipality-summary-header">
                Отчет по активности муниципалитета
            </Heading>
            <Separator margin={"none"} color="grey" />
            <Heading size={"h2"} className={styles.heading} name="municipality-overall-header">
                Основные показатели цифровизации
            </Heading>
            <div className={styles.summary}>
                <MunicipalitySummaryCard
                    municipalityId={municipalityId}
                    descriptionTitle="организаций в мониторинге"
                    descriptionText="Посмотрите показатели цифровизации ваших организаций"
                    percentage={municipalitySummaryData.percentOfDigitization}
                    title="Ежедневные данные муниципалитета по цифровизации"
                    info='Среднее значение всех показателей цифровизации, выводимых на "Панели управления отраслью спорта".'
                    value={municipalitySummaryData.organizationsCount}
                    municipalityPositionModel={{
                        municipalityPosition: municipalityRatingModel.municipalityPosition,
                        municipalityCount: municipalityRatingModel.municipalitiesCount,
                        municipalityRatingText:
                            "место муниципалитета по уровню цифровизации спорт. организаций в России на " +
                            toDateStringLocale(currentDate),
                    }}
                    dataTestName="municipality-summary"
                />
            </div>

            <div className={styles.box}>
                <MunicipalityIndicatorCard
                    denominator={municipalitySummaryData.coachesCount}
                    descriptionTitle={`подтвержденных учетных записей на ${toShortDateStringLocale(
                        currentDate,
                    )}`}
                    descriptionText="Не подтверждено"
                    numerator={municipalitySummaryData.activeCoachesCount}
                    percentage={municipalitySummaryData.activeCoachesPercent}
                    title="Тренеры"
                    info="Количество подтвержденных учетных записей тренеров относительно количества созданных учетных записей тренеров."
                    dataTestName="municipality-coaches"
                />
                <MunicipalityIndicatorCard
                    denominator={municipalitySummaryData.sportsmansCount}
                    descriptionTitle={`подтвержденных учетных записей на ${toShortDateStringLocale(
                        currentDate,
                    )}`}
                    descriptionText="Не подтверждено"
                    numerator={municipalitySummaryData.activeSportsmansCount}
                    percentage={municipalitySummaryData.activeSportsmansPercent}
                    title="Спортсмены"
                    info="Количество подтвержденных учетных записей спортсменов относительно количества созданных учетных записей спортсменов."
                    dataTestName="municipality-sportsmen"
                />
                <MunicipalityIndicatorCard
                    denominator={municipalitySummaryData.parentsCount}
                    descriptionTitle={`подтвержденных учетных записей на ${toShortDateStringLocale(
                        currentDate,
                    )}`}
                    descriptionText="Не подтверждено"
                    numerator={municipalitySummaryData.activeParentsCount}
                    percentage={municipalitySummaryData.activeParentsPercent}
                    title="Родители"
                    info="Количество подтвержденных учетных записей родителей относительно количества созданных учетных записей родителей."
                    dataTestName="municipality-parent"
                />
                <MunicipalityIndicatorCard
                    descriptionTitle={`выставлено отметок об отсутствии с ${toShortDateStringLocale(
                        previousWeekStartDate,
                    )}
                по ${toShortDateStringLocale(previousWeekEndDate)}`}
                    numerator={municipalitySummaryData.trainingSkippedCount}
                    percentage={municipalitySummaryData.attendancePercent}
                    title="Посещаемость"
                    info="Количество отметок об отсутствии, выставленных за прошлую неделю."
                    onClick={redirectToMunicipalitySchoolsAttendance}
                    dataTestName="municipality-attendance"
                />
                <MunicipalityIndicatorCard
                    denominator={municipalitySummaryData.organizationsCount}
                    descriptionTitle={`организаций заполнили расписание c ${toShortDateStringLocale(
                        currentWeekStartDate,
                    )}
                по ${toShortDateStringLocale(currentWeekEndDate)}`}
                    descriptionText="Не заполнили"
                    numerator={municipalitySummaryData.organizationsWithGoodScheduleCount}
                    percentage={municipalitySummaryData.goodSchedulePercent}
                    title="Расписание"
                    info="Количество организаций, которые заполнили расписание на текущую неделю, относительно всех организаций в муниципалитете."
                    dataTestName="municipality-schedule"
                />
                <MunicipalityIndicatorCard
                    denominator={municipalitySummaryData.organizationsCount}
                    descriptionTitle={`организаций заполнили журнал на 75% и более c ${toShortDateStringLocale(
                        previousWeekStartDate,
                    )}
                по ${toShortDateStringLocale(previousWeekEndDate)}`}
                    descriptionText="Не заполнили"
                    numerator={municipalitySummaryData.organizationsWithoutGoodJournalCount}
                    percentage={municipalitySummaryData.goodJournalPercent}
                    title="Журнал"
                    info={
                        'Количество организаций, у которых значение показателя "Журнал" равно 75% и выше, относительно всех организаций в муниципалитете.'
                    }
                    dataTestName="municipality-note"
                />
                <MunicipalityIndicatorCard
                    dataTestName="municipality_training_plans"
                    denominator={municipalitySummaryData.trainingsCount}
                    descriptionTitle={`тренировок с упражнениями с ${toShortDateStringLocale(
                        previousWeekStartDate,
                    )}
                по ${toShortDateStringLocale(previousWeekEndDate)}`}
                    numerator={municipalitySummaryData.trainingsWithFilledPlanCount}
                    percentage={municipalitySummaryData.trainingsWithFilledPlanPercentage}
                    title="Ведение планов тренировок"
                    info={
                        "Количество тренировок с упражнениями относительно общего количества тренировок."
                    }
                    onClick={redirectToMunicipalityTrainingPlans}
                />
            </div>
        </Card>
    );
}

MunicipalitySummaryView.propTypes = {
    currentDate: string.isRequired,
    previousWeekStartDate: string.isRequired,
    previousWeekEndDate: string.isRequired,
    currentWeekStartDate: string.isRequired,
    currentWeekEndDate: string.isRequired,
    municipalityId: number.isRequired,
    municipalitySummaryData: exact({
        organizationsCount: number.isRequired,
        coachesCount: number.isRequired,
        activeCoachesCount: number.isRequired,
        activeCoachesPercent: number.isRequired,
        sportsmansCount: number.isRequired,
        activeSportsmansCount: number.isRequired,
        activeSportsmansPercent: number.isRequired,
        parentsCount: number.isRequired,
        activeParentsCount: number.isRequired,
        activeParentsPercent: number.isRequired,
        organizationsWithGoodScheduleCount: number.isRequired,
        goodSchedulePercent: number.isRequired,
        organizationsWithoutGoodJournalCount: number.isRequired,
        goodJournalPercent: number.isRequired,
        percentOfDigitization: number.isRequired,
        trainingSkippedCount: number.isRequired,
        attendancePercent: number.isRequired,
        trainingsCount: number.isRequired,
        trainingsWithFilledPlanCount: number.isRequired,
        trainingsWithFilledPlanPercentage: number.isRequired,
    }).isRequired,
    municipalityRatingModel: exact({
        municipalityPosition: number.isRequired,
        municipalitiesCount: number.isRequired,
    }),
    municipalityStatsModelStatsModel: exact({
        federationEventsCount: number.isRequired,
        loadingPercent: number.isRequired,
    }),
};
